import { useState } from 'react';
import ContentCard from '../organisms/ContentCard/ContentCard';
import Button from '../atoms/Button';
import { useCreateInquiryMutation } from '@features/inquiry/hooks';
import useAuthStore from '@entities/auth/model/useAuthStore';

import styles from './InquiryFormModal.module.scss';
function InquiryFormModal({ onClose, onSuccess, onError }) {
  const { user, companyCode, enumber } = useAuthStore();
  const teamId = user?.teamCode;
  const [content, setContent] = useState('');
  const [inquiryType, setInquiryType] = useState(1);

  const { mutate, isPending } = useCreateInquiryMutation({
    onSuccess: () => {
      setContent('');
      onSuccess?.();
    },
    onError: (error) => {
      const message = error?.response?.data?.message || '문의 등록 중 오류가 발생했습니다.';
      onError?.(message);
    },
  });

  const handleSubmit = () => {
    if (!content.trim()) {
      alert('문의 내용을 입력해주세요.');
      return;
    }

    mutate({
      inquiryContent: content,
      teamId,
      companyCode,
      enumber,
      status: 0,
      inquiryType,
    });
  };

  return (
    <ContentCard className={styles.contentCardMarginFix}>
      <div>
        <div>이용하면서 느끼신 불편사항이나 바라는 점을 알려주세요</div>

        <div className={styles.formRow}>
          <label className={styles.label}>문의유형</label>
          <select
            className={styles.select}
            value={inquiryType}
            onChange={(e) => setInquiryType(Number(e.target.value))}
          >
            <option value={1}>서비스 불편 / 제안</option>
            <option value={2}>시스템 오류(PC/Mobile) 오류 제보</option>
            <option value={3}>서비스 개선 제안</option>
            <option value={4}>기타</option>
          </select>
        </div>

        <textarea
          className={styles.textarea}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="문의 내용을 입력해주세요."
        />
      </div>
      <div className={styles.buttonGroup}>
        <Button className={styles.cancelButton} onClick={onClose} disabled={isPending}>
          취소
        </Button>
        <Button className={styles.saveButton} onClick={handleSubmit} disabled={isPending}>
          확인
        </Button>
      </div>
    </ContentCard>
  );
}
export default InquiryFormModal;
